import React, { useEffect } from 'react';
import { useToast } from '../contexts/ToastContext';

/**
 * Routes auth-expired / auth-expiring-soon window events through ToastContext
 * with dedupe so parallel 401s produce one message.
 */
export const AuthSessionToasts: React.FC = () => {
  const { showToast } = useToast();

  useEffect(() => {
    const onExpired = () => {
      showToast('Your session expired. Sign in again to continue.', 'error', {
        dedupeKey: 'auth-expired',
        dedupeMs: 8000,
      });
    };

    const onExpiring = (event: Event) => {
      const detail = (event as CustomEvent).detail || {};
      const ms = typeof detail.timeUntilExpiry === 'number' ? detail.timeUntilExpiry : 0;
      const minutes = Math.max(1, Math.floor(ms / 60000));
      showToast(`Your session expires in about ${minutes} minute${minutes === 1 ? '' : 's'}.`, 'warning', {
        dedupeKey: 'auth-expiring-soon',
        dedupeMs: 60000,
      });
    };

    window.addEventListener('auth-expired', onExpired as EventListener);
    window.addEventListener('auth-expiring-soon', onExpiring as EventListener);
    return () => {
      window.removeEventListener('auth-expired', onExpired as EventListener);
      window.removeEventListener('auth-expiring-soon', onExpiring as EventListener);
    };
  }, [showToast]);

  return null;
};

export default AuthSessionToasts;
